export default "__VITE_ASSET__DCpcZOT5__"